import { httpService } from 'shared/api';
import { IApiKey, IApiKeyCreate } from './types';

const apiKeyEndpoint = '/api-keys';
export const apiKeyApi = {
  fetchAll: async () => {
    const response = await httpService.get<IApiKey[]>(apiKeyEndpoint + '/');
    return response.data;
  },
  create: async (data: IApiKeyCreate) => {
    const response = await httpService.post<IApiKey>(
      apiKeyEndpoint + '/',
      data
    );
    return response.data;
  },
  delete: async (id: string) => {
    const response = await httpService.delete(`${apiKeyEndpoint}/${id}`);
    return response.data;
  }
};
